"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardRow = exports.StyledCardLoader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledCardLoader = _styledComponents.default.div.withConfig({
  displayName: "CardLoaderstyle__StyledCardLoader",
  componentId: "sc-qys8vc-0"
})(["display:flex;flex-direction:column;"]);

exports.StyledCardLoader = StyledCardLoader;

const StyledCardRow = _styledComponents.default.div.withConfig({
  displayName: "CardLoaderstyle__StyledCardRow",
  componentId: "sc-qys8vc-1"
})(["display:flex;flex-direction:row;align-items:center;margin-top:32px;box-sizing:border-box;&:nth-child(2){margin-top:24px;}> div{:first-child{margin-right:24px;}}"]);

exports.StyledCardRow = StyledCardRow;